import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../Home.vue'
import Login from '../views/Login.vue'
import Demo from '../views/Demo.vue'
import CarDetail from '../views/CarDetail.vue'
import AdminLayout from '@/layouts/AdminLayout.vue'
import Bashbet from '@/views/Bashbet.vue'
import Topics from '@/views/Topics.vue'
import Themes from '@/views/Themes.vue'
import Quotes from '@/views/Quotes.vue'
import Names from '@/views/Names.vue'
import MiniUsers from '@/views/MiniUsers.vue'
import MiniUserDetail from '@/views/MiniUserDetail.vue'
import UserFavorites from '@/views/UserFavorites.vue'
import VipType from '@/views/VipType.vue'
import Memberships from '@/views/Memberships.vue'
import Profile from '@/views/Profile.vue'
import AdminUsers from '@/views/AdminUsers.vue'
import Origins from '@/views/Origins.vue'
import Tags from '@/views/Tags.vue'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

const adminChildren = [
  {
    path: 'welcome',
    name: 'AdminWelcome',
    component: Bashbet,
    meta: {
      title: 'Dashboard'
    }
  },
  {
    path: 'names',
    name: 'AdminNames',
    component: Names,
    meta: {
      title: 'Names Management'
    }
  },
  {
    path: 'topics',
    name: 'AdminTopics',
    component: Topics,
    meta: {
      title: 'Topics Management'
    }
  },
  {
    path: 'themes',
    name: 'AdminThemes',
    component: Themes,
    meta: {
      title: 'Themes Management'
    }
  },
  {
    path: 'quotes/:lang',
    name: 'AdminQuotes',
    component: Quotes,
    props: true,
    meta: {
      title: 'Quotes Management'
    }
  },
  {
    path: 'mini-users',
    name: 'AdminMiniUsers',
    component: MiniUsers,
    meta: {
      title: 'Mini Users Management'
    }
  },
  {
    path: 'mini-users/:id',
    name: 'AdminMiniUserDetail',
    component: MiniUserDetail,
    props: true,
    meta: {
      title: 'Mini User Detail'
    }
  },
  {
    path: 'mini-users/:id/favorites',
    name: 'AdminUserFavorites',
    component: UserFavorites,
    props: true,
    meta: {
      title: 'User Favorites'
    }
  },
  {
    path: 'vip-types',
    name: 'AdminVipTypes',
    component: VipType,
    meta: {
      title: 'VIP Types Management'
    }
  },
  {
    path: 'memberships',
    name: 'AdminMemberships',
    component: Memberships,
    meta: {
      title: 'Memberships Management'
    }
  },
  {
    path: 'profile',
    name: 'AdminProfile',
    component: Profile,
    meta: {
      title: 'User Profile'
    }
  },
  {
    path: 'admin-users',
    name: 'AdminUsers',
    component: AdminUsers,
    meta: {
      title: 'Users Management'
    }
  },
  {
    path: 'origins',
    name: 'AdminOrigins',
    component: Origins,
    meta: {
      title: 'Origins Management'
    }
  },
  {
    path: 'tags',
    name: 'AdminTags',
    component: Tags,
    meta: {
      title: 'Tags Management'
    }
  }
]

const routes = [
  {
    path: '/',
    redirect: '/home',
    meta: {
      public: true
    }
  },
  {
    path: '/home',
    name: '主页',
    component: Home,
    meta: {
      public: true,
      title: 'Home'
    }
  },
  {
    path: '/demo',
    name: 'AutoMart',
    component: Demo,
    meta: {
      public: true,
      title: 'AutoMart'
    }
  },
  {
    path: '/car/:id',
    name: 'CarDetail',
    component: CarDetail,
    meta: {
      public: true,
      title: '车辆详情'
    },
    props: true
  },
  {
    path: '/login',
    name: '登录',
    component: Login,
    meta: {
      public: true,
      title: 'Login'
    }
  },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/welcome',
    children: adminChildren
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta?.pageTitle || to.meta?.title || 'Namzar CMS'

  if (to.matched.some(record => record.meta?.public)) {
    return next()
  }

  if (!getToken()) {
    return next('/login')
  }

  next()
})

export default router